// import React, { useEffect, useState, useCallback, useRef } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useForm, Controller, SubmitHandler } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
// import { useLocation } from 'react-router-dom';
// import {
//   fetchApplicants,
//   setSelectedMember,
//   setSelectedIds,
//   addMember,
//   updateMember,
//   performApplicantAction,
//   clearAvatarError,
//   setActiveTab,
//   updateAvatarUrl,
//   FormData,
//   MembersReviewState,
//   getAvatarUrl
// } from 'slices/NdisSlices/platformAdmin/MembersReviewFormSlice';
// import { fetchGroups } from 'slices/NdisSlices/platformAdmin/PlatformAdminSlice';
// import { RootState, AppDispatch } from 'store';
// import { fetchRoles } from 'slices/NdisSlices/platformAdmin/ManageRolesSlice';

// import Avatar from '@mui/material/Avatar';
// import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
// import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
// import Checkbox from '@mui/material/Checkbox';
// import Chip from '@mui/material/Chip';
// import Container from '@mui/material/Container';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogTitle from '@mui/material/DialogTitle';
// import FormControl from '@mui/material/FormControl';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Grid from '@mui/material/Grid';
// import IconButton from '@mui/material/IconButton';
// import InputAdornment from '@mui/material/InputAdornment';
// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
// import Paper from '@mui/material/Paper';
// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
// import Select from '@mui/material/Select';
// import Switch from '@mui/material/Switch';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import TextField from '@mui/material/TextField';
// import { Typography, TypographyProps } from '@mui/material';
// import CircularProgress from '@mui/material/CircularProgress';
// import Snackbar from '@mui/material/Snackbar';
// import Alert from '@mui/material/Alert';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { useTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import ClearIcon from '@mui/icons-material/Clear';

// import Cancel from '@mui/icons-material/Cancel';
// import CheckCircle from '@mui/icons-material/CheckCircle';
// import Delete from '@mui/icons-material/Delete';
// import Edit from '@mui/icons-material/Edit';
// import Search from '@mui/icons-material/Search';
// import CloudUpload from '@mui/icons-material/CloudUpload';
// import CalendarMonth from '@mui/icons-material/CalendarMonth';

// const schema: yup.ObjectSchema<FormData> = yup.object().shape({
//   id: yup.string().optional(),
//   name: yup.string().required('Full Name is required'),
//   username: yup.string().optional(),
//   role: yup
//     .array()
//     .of(
//       yup.object().shape({
//         role_id: yup.string().required(),
//         label: yup.string().required()
//       })
//     )
//     .optional(),
//   gender: yup.string().optional(),
//   phone: yup.string().required('Phone is required'),
//   email: yup.string().email('Invalid email').required('Email is required'),
//   dob: yup.date().required('Date of Birth is required').typeError('Invalid date'),
//   address: yup.string().optional(),
//   projects: yup.array().of(yup.string().defined()).optional(),
//   groups: yup.array().of(yup.string().defined()).optional(),
//   avartar: yup.string().optional(),
//   creation_date_time: yup.string().optional(),
//   created_by: yup.string().optional(),
//   department: yup.string().optional(),
//   status: yup
//     .string()
//     .oneOf(['active', 'inactive', 'verify pending', 'approval pending', 'rejected'])
//     .required('Status is required'),
//   isActive: yup.boolean().optional()
// });

// const defaultFormValues: FormData = {
//   id: '',
//   name: '',
//   username: '',
//   role: [],
//   gender: 'male',
//   phone: '',
//   email: '',
//   dob: new Date(),
//   address: '',
//   projects: [],
//   groups: [],
//   avartar: '',
//   creation_date_time: '',
//   created_by: '',
//   department: '',
//   status: 'active',
//   isActive: true
// };

// const validTabs = [
//   'Verification Pending',
//   'Approval Pending',
//   'Rejected Applicants',
//   'Approved'
// ] as const;

// const useResponsiveTypography = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   return {
//     h4: (isMobile ? 'h5' : 'h4') as TypographyProps['variant'],
//     h5: (isMobile ? 'h6' : 'h5') as TypographyProps['variant'],
//     h6: (isMobile ? 'subtitle1' : 'h6') as TypographyProps['variant'],
//     subtitle1: (isMobile ? 'subtitle2' : 'subtitle1') as TypographyProps['variant'],
//     body1: (isMobile ? 'body2' : 'body1') as TypographyProps['variant'],
//     body2: (isMobile ? 'caption' : 'body2') as TypographyProps['variant'],
//     caption: 'caption' as TypographyProps['variant']
//   };
// };

// const MemberReviewForm: React.FC = () => {
//   const scrollableDivRef = useRef<HTMLDivElement>(null);
//   const formRef = useRef<HTMLDivElement>(null);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const typography = useResponsiveTypography();

//   const [searchTerm, setSearchTerm] = useState<string>('');
//   const [isActive, setIsActive] = useState(true);
//   const [open, setOpen] = useState(false);
//   const [startDate, setStartDate] = useState<Date | null>(null);
//   const [endDate, setEndDate] = useState<Date | null>(null);
//   const [selectedClient, setSelectedClient] = useState<{ label: string } | null>(null);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState<'error' | 'success'>('error');
//   const [avatarFile, setAvatarFile] = useState<File | null>(null);
//   const [avatarPreview, setAvatarPreview] = useState<string | null>(null);
//   const avatarBlobUrls = useRef<{ [id: string]: string }>({});

//   const initialLoadComplete = useRef(false);

//   const dispatch = useDispatch<AppDispatch>();
//   const {
//     members,
//     selectedMember,
//     selectedIds,
//     loading,
//     error,
//     avatarLoading,
//     avatarError,
//     avatarUrls,
//     activeTab
//   } = useSelector((state: RootState) => state.membersReview as MembersReviewState);

//   console.log('selectedMember', selectedMember);
//   const groups = useSelector((state: RootState) => state.platformAdmin?.groups || []);
//   const { roles } = useSelector((state: RootState) => state.manageRoles);

//   const selectedProjectId = useSelector(
//     (state: RootState) => (state as any).homeTilesServices?.selectedProjectId || ''
//   );

//   const selectedServiceTitle = useSelector(
//     (state: RootState) => (state as any).serviceSelected?.selectedServiceTitle || ''
//   );

//   const userDetails = localStorage.getItem('user-details');
//   const loggedInWorkerName = userDetails ? JSON.parse(userDetails)?.name || '' : '';

//   const location = useLocation();
//   const componentParentId = location.pathname;

//   const {
//     control,
//     handleSubmit,
//     reset,
//     setValue,
//     getValues,
//     formState: { errors }
//   } = useForm<FormData>({
//     resolver: yupResolver(schema),
//     defaultValues: defaultFormValues
//   });

//   // Persist activeTab in localStorage
//   useEffect(() => {
//     localStorage.setItem('activeTab', activeTab);
//   }, [activeTab]);

//   // Restore activeTab on mount
//   useEffect(() => {
//     if (!initialLoadComplete.current) {
//       const savedTab = localStorage.getItem('activeTab');
//       console.log('Restored activeTab from localStorage:', savedTab);
//       if (savedTab && validTabs.includes(savedTab as any)) {
//         dispatch(setActiveTab(savedTab as any));
//         dispatch(fetchApplicants(savedTab as any));
//       } else {
//         dispatch(setActiveTab('Verification Pending'));
//         dispatch(fetchApplicants('Verification Pending'));
//       }
//       dispatch(fetchGroups());
//       dispatch(fetchRoles());
//       dispatch(setSelectedMember(null));
//       reset(defaultFormValues);
//       initialLoadComplete.current = true;
//     }
//   }, [dispatch, reset]);

//   // Fetch avatars for members
//   useEffect(() => {
//     console.log('fetchAvatars called...');
//     const fetchAvatars = async () => {
//       for (const member of members) {
//         // if (member.id && member.avartar && !avatarUrls[member.id]) {
//         try {
//           console.log(`Fetching avatar for member ${member.id}: ${member.avartar}`);
//           const url = await getAvatarUrl(member.avartar || '');
//           dispatch(updateAvatarUrl({ id: member.id || '', url }));
//           avatarBlobUrls.current[member.id || ''] = url;
//         } catch (err) {
//           console.error(`Failed to fetch avatar for member ${member.id}:`, err);
//         }
//         // }
//       }
//     };
//     fetchAvatars();
//   }, [members, dispatch]);

//   // Update avatar preview when avatarFile changes
//   useEffect(() => {
//     if (avatarFile) {
//       const previewUrl = URL.createObjectURL(avatarFile);
//       setAvatarPreview(previewUrl);
//       return () => URL.revokeObjectURL(previewUrl);
//     } else {
//       setAvatarPreview(null);
//     }
//   }, [avatarFile]);

//   // Cleanup blob URLs on unmount
//   useEffect(() => {
//     return () => {
//       Object.values(avatarBlobUrls.current).forEach((url) => {
//         if (url.startsWith('blob:')) {
//           URL.revokeObjectURL(url);
//         }
//       });
//       avatarBlobUrls.current = {};
//       if (avatarPreview) {
//         URL.revokeObjectURL(avatarPreview);
//       }
//     };
//   }, [avatarPreview]);

//   // Reset form when selectedMember changes to null
//   useEffect(() => {
//     if (!selectedMember) {
//       reset(defaultFormValues);
//       setAvatarFile(null);
//       setAvatarPreview(null);
//       setIsActive(true);
//       setSelectedClient(null);
//     }
//   }, [selectedMember, reset]);

//   useEffect(() => {
//     if (error || avatarError) {
//       setSnackbarMessage(error || avatarError || 'An error occurred');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }
//   }, [error, avatarError]);

//   const handleCloseSnackbar = () => {
//     setSnackbarOpen(false);
//     dispatch(clearAvatarError());
//   };

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   const handleTabChange = (
//     event: React.SyntheticEvent,
//     newValue: 'Verification Pending' | 'Approval Pending' | 'Rejected Applicants' | 'Approved'
//   ) => {
//     dispatch(setActiveTab(newValue));
//     dispatch(fetchApplicants(newValue));
//     dispatch(setSelectedMember(null));
//     dispatch(setSelectedIds([]));
//     reset(defaultFormValues);
//     setSelectedClient(null);
//     setIsActive(true);
//     setAvatarFile(null);
//     setAvatarPreview(null);
//   };

//   const handleAvatarError = useCallback((e: React.SyntheticEvent<HTMLImageElement, Event>) => {
//     const target = e.target as HTMLImageElement;
//     target.onerror = null;
//     target.src = '/default-avatar.png';
//   }, []);

//   const onSubmit: SubmitHandler<FormData> = async (data) => {
//     if (activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants') return;

//     const finalData = {
//       ...data,
//       avartar: avatarFile ? data.avartar : selectedMember?.avartar || ''
//     };

//     const payload = {
//       data: finalData,
//       selectedProjectId,
//       selectedServiceTitle,
//       loggedInWorkerName,
//       componentParentId,
//       user_whoRequested_id: selectedClient?.label || '',
//       avatarFile
//     };

//     try {
//       if (selectedMember?.id) {
//         console.log('Updating member with payload:', {
//           data: finalData,
//           avatarFile: avatarFile?.name,
//           avatarPath: finalData.avartar
//         });
//         const result = await dispatch(updateMember(payload)).unwrap();
//         console.log('Update member response:', result);
//         setSnackbarMessage('Member updated successfully');
//         setSnackbarSeverity('success');
//         if (avatarFile && avatarPreview && selectedMember.id) {
//           dispatch(updateAvatarUrl({ id: selectedMember.id, url: avatarPreview }));
//           avatarBlobUrls.current[selectedMember.id] = avatarPreview;
//         } else if (finalData.avartar && selectedMember.id) {
//           dispatch(updateAvatarUrl({ id: selectedMember.id, url: '' }));
//           try {
//             const newAvatarUrl = await getAvatarUrl(finalData.avartar);
//             dispatch(updateAvatarUrl({ id: selectedMember.id, url: newAvatarUrl }));
//             avatarBlobUrls.current[selectedMember.id] = newAvatarUrl;
//           } catch (err) {
//             console.error(`Failed to fetch updated avatar for ${selectedMember.id}:`, err);
//             dispatch(updateAvatarUrl({ id: selectedMember.id, url: '/default-avatar.png' }));
//           }
//         }
//         await dispatch(fetchApplicants(activeTab)).unwrap();
//       } else {
//         await dispatch(addMember(payload)).unwrap();
//         setSnackbarMessage('Member added successfully');
//         setSnackbarSeverity('success');
//         await dispatch(fetchApplicants(activeTab)).unwrap();
//       }

//       setSnackbarOpen(true);
//       reset(defaultFormValues);
//       setAvatarFile(null);
//       setAvatarPreview(null);
//       setIsActive(true);
//       setSelectedClient(null);
//       dispatch(setSelectedMember(null));
//       dispatch(setSelectedIds([]));
//     } catch (err) {
//       console.error('Error during submit:', err);
//       setSnackbarMessage('Failed to save member');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }
//   };

//   // const handleListItemClick = (member: FormData) => {
//   //   console.log("selectedMember",member)
//   //   if (scrollableDivRef.current) {
//   //     scrollableDivRef.current.scrollTo({
//   //       top: formRef.current?.offsetTop || 0,
//   //       behavior: 'smooth'
//   //     });
//   //   }

//   //   if (activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants') return;

//   //   dispatch(setSelectedMember(member));
//   //   setIsActive(member.isActive ?? member.status === 'active');
//   //   reset({
//   //     ...member,
//   //     dob: member.dob ? new Date(member.dob) : new Date(),
//   //     projects: member.projects || [],
//   //     groups: member.groups || [],
//   //     status: member.status || 'active',
//   //     avartar: member.avartar || '',
//   //     isActive: member.isActive ?? member.status === 'active'
//   //   });
//   //   setAvatarFile(null);
//   //   setAvatarPreview(null);
//   // };

//   const handleListItemClick = (member: FormData) => {
//     if (scrollableDivRef.current) {
//       scrollableDivRef.current.scrollTo({
//         top: formRef.current?.offsetTop || 0,
//         behavior: 'smooth'
//       });
//     }

//     if (activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants') return;

//     // Transform the role data to match the expected format
//     const transformedRoles =
//       member.role?.flatMap((roleItem) => {
//         // Handle both possible role structures
//         if (Array.isArray(roleItem.role_id)) {
//           return roleItem.role_id.map((role) => ({
//             role_id: role.role_id,
//             label: role.label
//           }));
//         } else if (roleItem.role_id) {
//           // Handle single role case
//           return [
//             {
//               role_id: roleItem.role_id,
//               label: roleItem.label || ''
//             }
//           ];
//         }
//         return [];
//       }) || [];

//     dispatch(setSelectedMember(member));
//     setIsActive(member.isActive ?? member.status === 'active');

//     // Prepare the form data with all fields
//     const formData = {
//       ...member,
//       dob: member.dob ? new Date(member.dob) : new Date(),
//       projects: member.projects || [],
//       groups: member.groups || [],
//       status: member.status || 'active',
//       avartar: member.avartar || '',
//       isActive: member.isActive ?? member.status === 'active',
//       role: transformedRoles,
//       // Ensure all required fields are included
//       name: member.name || '',
//       email: member.email || '',
//       phone: member.phone || '',
//       address: member.address || '',
//       gender: member.gender || 'male',
//       username: member.username || member.email || '',
//       department: member.department || '',
//       creation_date_time: member.creation_date_time || '',
//       created_by: member.created_by || ''
//     };

//     reset(formData);
//     setAvatarFile(null);
//     setAvatarPreview(null);
//   };

//   const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
//     if (activeTab === 'Verification Pending') return;

//     if (event.target.checked) {
//       const newSelecteds = members
//         .map((member: FormData) => member.id!)
//         .filter((id): id is string => !!id);
//       dispatch(setSelectedIds(newSelecteds));
//       return;
//     }
//     dispatch(setSelectedIds([]));
//   };

//   const handleCheckboxClick = (id: string) => {
//     if (activeTab === 'Verification Pending') return;

//     const selectedIndex = selectedIds.indexOf(id);
//     let newSelected: string[] = [];

//     if (selectedIndex === -1) {
//       newSelected = [...selectedIds, id];
//     } else {
//       newSelected = selectedIds.filter((item: string) => item !== id);
//     }

//     dispatch(setSelectedIds(newSelected));
//   };

//   const handleBulkAction = async (action: 'approve' | 'reject' | 'delete') => {
//     if (activeTab === 'Verification Pending' || selectedIds.length === 0) return;

//     const payload = selectedIds.map((id: string) => ({
//       id,
//       email: members.find((member: FormData) => member.id === id)?.email || ''
//     }));

//     try {
//       await dispatch(
//         performApplicantAction({ membersData: payload, action, tab: activeTab })
//       ).unwrap();
//       setSnackbarMessage(`Bulk ${action} successful`);
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       dispatch(setSelectedIds([]));
//       if (selectedMember && payload.some((p: { id: string }) => p.id === selectedMember.id)) {
//         reset(defaultFormValues);
//         dispatch(setSelectedMember(null));
//         setSelectedClient(null);
//         setIsActive(true);
//         setAvatarFile(null);
//         setAvatarPreview(null);
//       }
//       await dispatch(fetchApplicants(activeTab)).unwrap();
//     } catch (err) {
//       setSnackbarMessage(`Failed to perform bulk ${action}`);
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }
//   };

//   const handleIndividualAction = async (action: 'approve' | 'reject' | 'delete') => {
//     if (activeTab === 'Verification Pending' || !selectedMember?.id) return;

//     const payload = [{ id: selectedMember.id, email: selectedMember.email }];

//     try {
//       await dispatch(
//         performApplicantAction({ membersData: payload, action, tab: activeTab })
//       ).unwrap();
//       setSnackbarMessage(`${action.charAt(0).toUpperCase() + action.slice(1)} successful`);
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       reset(defaultFormValues);
//       dispatch(setSelectedMember(null));
//       dispatch(setSelectedIds([]));
//       setSelectedClient(null);
//       setIsActive(true);
//       setAvatarFile(null);
//       setAvatarPreview(null);
//       await dispatch(fetchApplicants(activeTab)).unwrap();
//     } catch (err) {
//       setSnackbarMessage(`Failed to ${action} member`);
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }
//   };

//   const handleAvatarUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
//     if (activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants') return;

//     const file = event.target.files?.[0];
//     if (file) {
//       setAvatarFile(file);
//       const { email } = getValues();
//       if (email) {
//         const extension = file.name.split('.').pop() || 'png';
//         setValue(
//           'avartar',
//           `Users/ApprovedMembers/${email.replace('@', '_').replace('.', '_')}/image.${extension}`
//         );
//       }
//     }
//   };

//   const handleAvatarRemove = () => {
//     if (activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants') return;

//     setValue('avartar', '');
//     setAvatarFile(null);
//     setAvatarPreview(null);
//   };

//   const filteredMembers = React.useMemo(() => {
//     return members.filter((member: FormData) =>
//       member.name.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }, [members, searchTerm]);

//   const statusMap = {
//     active: { label: 'Active', color: 'success' as const },
//     inactive: { label: 'Inactive', color: 'error' as const },
//     pending: { label: 'Pending', color: 'warning' as const }
//   };

//   console.log('errors', errors);
//   return (
//     <Container
//       maxWidth="lg"
//       sx={{
//         py: isMobile ? 1 : 3,
//         px: isMobile ? 1 : 3
//       }}
//       ref={scrollableDivRef}
//     >
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>

//       <Box sx={{ mb: isMobile ? 1 : 2 }}>
//         <Grid container alignItems="center" justifyContent="space-between">
//           <Grid item>
//             <Typography variant={typography.h4} fontWeight="bold">
//               Review Member
//             </Typography>
//           </Grid>
//           {activeTab !== 'Verification Pending' && activeTab !== 'Rejected Applicants' && (
//             <Grid item>
//               <Box sx={{ display: 'flex', gap: 1 }}>
//                 {activeTab === 'Approval Pending' && (
//                   <>
//                     <Button
//                       variant="outlined"
//                       color="secondary"
//                       size="small"
//                       startIcon={<Cancel />}
//                       onClick={() => handleIndividualAction('reject')}
//                       disabled={!selectedMember || loading}
//                     >
//                       {isMobile ? '' : 'Reject'}
//                     </Button>
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       size="small"
//                       startIcon={<CheckCircle />}
//                       onClick={() => handleIndividualAction('approve')}
//                       disabled={!selectedMember || loading}
//                     >
//                       {isMobile ? '' : 'Approve'}
//                     </Button>
//                   </>
//                 )}
//                 {activeTab === 'Approved' && (
//                   <Button
//                     variant="contained"
//                     color="error"
//                     size="small"
//                     startIcon={<Delete />}
//                     onClick={() => handleIndividualAction('delete')}
//                     disabled={!selectedMember || loading}
//                   >
//                     {isMobile ? '' : 'Delete'}
//                   </Button>
//                 )}
//               </Box>
//             </Grid>
//           )}
//         </Grid>
//       </Box>

//       <Grid container spacing={isMobile ? 1 : 3} ref={formRef}>
//         <Grid item xs={12} md={4}>
//           <Card
//             sx={{
//               p: isMobile ? 1 : 2,
//               textAlign: 'center',
//               height: '100%'
//             }}
//           >
//             <CardContent sx={{ p: isMobile ? 1 : 2 }}>
//               <Avatar
//                 src={
//                   avatarPreview ||
//                   (selectedMember?.id
//                     ? avatarUrls[selectedMember.id] || '/default-avatar.png'
//                     : '/default-avatar.png')
//                 }
//                 sx={{
//                   width: isMobile ? 60 : 80,
//                   height: isMobile ? 60 : 80,
//                   mx: 'auto',
//                   mb: isMobile ? 1 : 2
//                 }}
//                 imgProps={{ onError: handleAvatarError }}
//               />
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'center',
//                   gap: isMobile ? 0.5 : 1,
//                   flexWrap: isMobile ? 'wrap' : 'nowrap'
//                 }}
//               >
//                 <Button
//                   variant="contained"
//                   size="small"
//                   component="label"
//                   disabled={
//                     !selectedMember ||
//                     avatarLoading ||
//                     activeTab === 'Verification Pending' ||
//                     activeTab === 'Rejected Applicants'
//                   }
//                   sx={{ minWidth: isMobile ? '100%' : 'auto', mb: isMobile ? 1 : 0 }}
//                 >
//                   {avatarLoading ? <CircularProgress size={20} /> : 'Change'}
//                   <input type="file" hidden onChange={handleAvatarUpload} accept="image/*" />
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   size="small"
//                   color="secondary"
//                   onClick={handleAvatarRemove}
//                   disabled={
//                     !selectedMember ||
//                     avatarLoading ||
//                     activeTab === 'Verification Pending' ||
//                     activeTab === 'Rejected Applicants'
//                   }
//                   sx={{ minWidth: isMobile ? '100%' : 'auto' }}
//                 >
//                   Remove
//                 </Button>
//               </Box>
//             </CardContent>
//             <Box
//               sx={{
//                 mt: isMobile ? 1 : 2,
//                 p: isMobile ? 1 : 2,
//                 border: '2px dashed #ccc',
//                 borderRadius: 1,
//                 textAlign: 'center',
//                 cursor:
//                   activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants'
//                     ? 'not-allowed'
//                     : 'pointer',
//                 bgcolor:
//                   activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants'
//                     ? '#f5f5f5'
//                     : '#fafafa',
//                 '&:hover': {
//                   bgcolor:
//                     activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants'
//                       ? '#f5f5f5'
//                       : '#f0f0f0'
//                 }
//               }}
//             >
//               <CloudUpload sx={{ fontSize: isMobile ? 30 : 40, color: 'gray' }} />
//               <Typography variant={typography.body2} fontWeight={500} mt={1}>
//                 Drag & Drop your files here
//               </Typography>
//               <Typography variant={typography.body2} color="gray">
//                 OR
//               </Typography>
//               <Button
//                 component="label"
//                 variant="outlined"
//                 size="small"
//                 startIcon={<CloudUpload />}
//                 sx={{
//                   mt: 1,
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 disabled={
//                   !selectedMember ||
//                   avatarLoading ||
//                   activeTab === 'Verification Pending' ||
//                   activeTab === 'Rejected Applicants'
//                 }
//               >
//                 {avatarLoading ? <CircularProgress size={20} /> : 'Browse Files'}
//                 <input type="file" hidden onChange={handleAvatarUpload} accept="image/*" />
//               </Button>
//             </Box>
//           </Card>
//         </Grid>

//         <Grid item xs={12} md={8}>
//           <Card sx={{ p: isMobile ? 1 : 2, height: '100%' }}>
//             <CardContent sx={{ p: isMobile ? 1 : 2 }}>
//               <form onSubmit={handleSubmit(onSubmit)}>
//                 <Box
//                   display="flex"
//                   justifyContent="space-between"
//                   alignItems="center"
//                   mb={isMobile ? 1 : 2}
//                   flexDirection={isMobile ? 'column' : 'row'}
//                   gap={isMobile ? 1 : 0}
//                 >
//                   <Typography variant={typography.h6} fontWeight={600}>
//                     General Information
//                   </Typography>
//                   <Controller
//                     name="isActive"
//                     control={control}
//                     render={({ field }) => (
//                       <FormControlLabel
//                         control={
//                           <Switch
//                             checked={field.value ?? isActive}
//                             onChange={(e) => {
//                               field.onChange(e.target.checked);
//                               setIsActive(e.target.checked);
//                               setValue('status', e.target.checked ? 'active' : 'inactive');
//                             }}
//                             color="primary"
//                             disabled={
//                               activeTab === 'Verification Pending' ||
//                               activeTab === 'Rejected Applicants' ||
//                               loading
//                             }
//                             sx={{
//                               '& .MuiSwitch-track': {
//                                 background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
//                               },
//                               '& .Mui-checked': {
//                                 '& .MuiSwitch-track': {
//                                   background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)'
//                                 },
//                                 '& .MuiSwitch-thumb': {
//                                   backgroundColor: '#2196F3 !important'
//                                 }
//                               },
//                               '& .MuiSwitch-thumb': {
//                                 backgroundColor: '#ff4081'
//                               }
//                             }}
//                           />
//                         }
//                         label={
//                           <Typography variant={typography.body2}>
//                             {field.value ?? isActive ? 'Active' : 'Inactive'}
//                           </Typography>
//                         }
//                       />
//                     )}
//                   />
//                 </Box>

//                 <Grid container spacing={isMobile ? 1 : 2}>
//                   <Grid item xs={12} sm={6}>
//                     <Controller
//                       name="name"
//                       control={control}
//                       render={({ field }) => (
//                         <TextField
//                           {...field}
//                           label="Full Name"
//                           variant="outlined"
//                           fullWidth
//                           size="small"
//                           error={!!errors.name}
//                           helperText={errors.name?.message}
//                           disabled={
//                             activeTab === 'Verification Pending' ||
//                             activeTab === 'Rejected Applicants' ||
//                             loading
//                           }
//                         />
//                       )}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Controller
//                       name="username"
//                       control={control}
//                       render={({ field }) => (
//                         <TextField
//                           {...field}
//                           label="Username"
//                           variant="outlined"
//                           fullWidth
//                           size="small"
//                           error={!!errors.username}
//                           helperText={errors.username?.message}
//                           disabled={
//                             activeTab === 'Verification Pending' ||
//                             activeTab === 'Rejected Applicants' ||
//                             loading
//                           }
//                         />
//                       )}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <Controller
//                       name="gender"
//                       control={control}
//                       render={({ field }) => (
//                         <RadioGroup row {...field}>
//                           <FormControlLabel
//                             value="male"
//                             control={<Radio size="small" checked={field.value === 'male'} />}
//                             label={<Typography variant={typography.body2}>Male</Typography>}
//                             disabled={
//                               activeTab === 'Verification Pending' ||
//                               activeTab === 'Rejected Applicants' ||
//                               loading
//                             }
//                           />
//                           <FormControlLabel
//                             value="female"
//                             control={<Radio size="small" checked={field.value === 'female'} />}
//                             label={<Typography variant={typography.body2}>Female</Typography>}
//                             disabled={
//                               activeTab === 'Verification Pending' ||
//                               activeTab === 'Rejected Applicants' ||
//                               loading
//                             }
//                           />
//                           <FormControlLabel
//                             value="other"
//                             control={<Radio size="small" checked={field.value === 'other'} />}
//                             label={<Typography variant={typography.body2}>Other</Typography>}
//                             disabled={
//                               activeTab === 'Verification Pending' ||
//                               activeTab === 'Rejected Applicants' ||
//                               loading
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Controller
//                       name="phone"
//                       control={control}
//                       render={({ field }) => (
//                         <TextField
//                           {...field}
//                           label="Phone"
//                           variant="outlined"
//                           fullWidth
//                           size="small"
//                           error={!!errors.phone}
//                           helperText={errors.phone?.message}
//                           disabled={
//                             activeTab === 'Verification Pending' ||
//                             activeTab === 'Rejected Applicants' ||
//                             loading
//                           }
//                         />
//                       )}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Controller
//                       name="email"
//                       control={control}
//                       render={({ field }) => (
//                         <TextField
//                           {...field}
//                           label="Email"
//                           variant="outlined"
//                           fullWidth
//                           size="small"
//                           error={!!errors.email}
//                           helperText={errors.email?.message}
//                           disabled={
//                             activeTab === 'Verification Pending' ||
//                             activeTab === 'Rejected Applicants' ||
//                             loading
//                           }
//                         />
//                       )}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Controller
//                       name="dob"
//                       control={control}
//                       render={({ field }) => (
//                         <LocalizationProvider dateAdapter={AdapterDateFns}>
//                           <DatePicker
//                             label="Date of Birth"
//                             value={field.value}
//                             onChange={(date: any) => field.onChange(date)}
//                             maxDate={new Date()}
//                             slots={{ textField: TextField }}
//                             slotProps={{
//                               textField: {
//                                 fullWidth: true,
//                                 size: 'small',
//                                 error: !!errors.dob,
//                                 helperText: errors.dob?.message,
//                                 disabled:
//                                   activeTab === 'Verification Pending' ||
//                                   activeTab === 'Rejected Applicants' ||
//                                   loading
//                               }
//                             }}
//                           />
//                         </LocalizationProvider>
//                       )}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <Controller
//                       name="address"
//                       control={control}
//                       render={({ field }) => (
//                         <TextField
//                           {...field}
//                           label="Address (Suburb, State, Country, Postcode)"
//                           variant="outlined"
//                           fullWidth
//                           size="small"
//                           error={!!errors.address}
//                           helperText={errors.address?.message}
//                           disabled={
//                             activeTab === 'Verification Pending' ||
//                             activeTab === 'Rejected Applicants' ||
//                             loading
//                           }
//                         />
//                       )}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Controller
//                       name="department"
//                       control={control}
//                       render={({ field }) => (
//                         <FormControl
//                           fullWidth
//                           size="small"
//                           error={!!errors.department}
//                           disabled={
//                             activeTab === 'Verification Pending' ||
//                             activeTab === 'Rejected Applicants' ||
//                             loading
//                           }
//                         >
//                           <InputLabel>Department</InputLabel>
//                           <Select
//                             {...field}
//                             label="Department"
//                             onChange={(e) => field.onChange(e.target.value)}
//                             renderValue={(selected) =>
//                               groups.find((g) => g.group_id === selected)?.label || ''
//                             }
//                             endAdornment={
//                               field.value && (
//                                 <IconButton
//                                   sx={{ display: 'flex', mr: 1 }}
//                                   onClick={() => field.onChange('')}
//                                   size="small"
//                                 >
//                                   <ClearIcon fontSize="small" />
//                                 </IconButton>
//                               )
//                             }
//                           >
//                             <MenuItem value="">
//                               <em>None</em>
//                             </MenuItem>
//                             {groups.map((group) => (
//                               <MenuItem key={group.group_id} value={group.group_id}>
//                                 {group.label}
//                               </MenuItem>
//                             ))}
//                           </Select>
//                           {errors.department && (
//                             <Typography color="error" variant={typography.caption}>
//                               {errors.department.message}
//                             </Typography>
//                           )}
//                         </FormControl>
//                       )}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Controller
//                       name="role"
//                       control={control}
//                       render={({ field }) => (
//                         <FormControl
//                           fullWidth
//                           size="small"
//                           error={!!errors.role}
//                           disabled={
//                             activeTab === 'Verification Pending' ||
//                             activeTab === 'Rejected Applicants' ||
//                             loading
//                           }
//                           sx={{ bgcolor: 'background.paper' }}
//                         >
//                           <InputLabel sx={{ color: 'text.secondary' }}>Role</InputLabel>
//                           <Select
//                             {...field}
//                             label="Role"
//                             multiple
//                             value={(field.value || []).map((r) => r.role_id)}
//                             onChange={(e) => {
//                               const selectedIds = e.target.value as string[];
//                               const selectedRoles = selectedIds
//                                 .map((id) => {
//                                   const role = roles.find((r) => r.role_id === id);
//                                   return role ? { role_id: role.role_id, label: role.label } : null;
//                                 })
//                                 .filter((r): r is { role_id: string; label: string } => r !== null);
//                               field.onChange(selectedRoles);
//                             }}
//                             renderValue={(selected) =>
//                               (selected as string[])
//                                 .map((id) => roles.find((r) => r.role_id === id)?.label || id)
//                                 .join(', ')
//                             }
//                             sx={{ color: 'text.primary' }}
//                           >
//                             {roles.map((role) => (
//                               <MenuItem key={role.role_id} value={role.role_id}>
//                                 {role.label}
//                               </MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       )}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <Controller
//                       name="groups"
//                       control={control}
//                       render={({ field }) => (
//                         <FormControl
//                           fullWidth
//                           size="small"
//                           error={!!errors.groups}
//                           disabled={
//                             activeTab === 'Verification Pending' ||
//                             activeTab === 'Rejected Applicants' ||
//                             loading
//                           }
//                         >
//                           <InputLabel>Groups</InputLabel>
//                           <Select
//                             {...field}
//                             multiple
//                             label="Groups"
//                             onChange={(e) => {
//                               const value = e.target.value;
//                               field.onChange(typeof value === 'string' ? value.split(',') : value);
//                             }}
//                             renderValue={(selected) =>
//                               (selected as string[])
//                                 .map((id) => groups.find((g) => g.group_id === id)?.label || id)
//                                 .join(', ')
//                             }
//                             endAdornment={
//                               field.value &&
//                               (field.value as string[]).length > 0 && (
//                                 <IconButton
//                                   sx={{ display: 'flex', mr: 1 }}
//                                   onClick={() => field.onChange([])}
//                                   size="small"
//                                 >
//                                   <ClearIcon fontSize="small" />
//                                 </IconButton>
//                               )
//                             }
//                           >
//                             {groups.map((group) => (
//                               <MenuItem key={group.group_id} value={group.group_id}>
//                                 {group.label}
//                               </MenuItem>
//                             ))}
//                           </Select>
//                           {errors.groups && (
//                             <Typography color="error" variant={typography.caption}>
//                               {errors.groups.message}
//                             </Typography>
//                           )}
//                         </FormControl>
//                       )}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       color="primary"
//                       size="small"
//                       disabled={
//                         activeTab === 'Verification Pending' ||
//                         activeTab === 'Rejected Applicants' ||
//                         activeTab === 'Approval Pending' ||
//                         loading
//                       }
//                       sx={{ width: isMobile ? '100%' : 'auto' }}
//                     >
//                       {loading ? (
//                         <CircularProgress size={20} />
//                       ) : selectedMember ? (
//                         'Update'
//                       ) : (
//                         'Save'
//                       )}
//                     </Button>
//                   </Grid>
//                 </Grid>
//               </form>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       <Box sx={{ mt: isMobile ? 2 : 4 }}>
//         <Tabs
//           value={activeTab}
//           onChange={handleTabChange}
//           aria-label="member status tabs"
//           sx={{ mb: isMobile ? 1 : 2 }}
//           variant={isMobile ? 'scrollable' : 'standard'}
//           scrollButtons="auto"
//         >
//           <Tab label="Verification Pending" value="Verification Pending" disabled={loading} />
//           <Tab label="Approval Pending" value="Approval Pending" disabled={loading} />
//           <Tab label="Rejected Applicants" value="Rejected Applicants" disabled={loading} />
//           <Tab label="Approved Members" value="Approved" disabled={loading} />
//         </Tabs>

//         <Grid container spacing={1} alignItems="center">
//           <Grid item xs={12}>
//             <Typography variant={typography.h6} fontWeight={600}>
//               Member List
//             </Typography>
//           </Grid>

//           <Grid item xs={12}>
//             <Grid container spacing={1} alignItems="center">
//               <Grid item xs={12} sm={8} md={9}>
//                 <TextField
//                   fullWidth
//                   variant="outlined"
//                   size="small"
//                   placeholder="Search members..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Search />
//                       </InputAdornment>
//                     )
//                   }}
//                   disabled={loading}
//                 />
//               </Grid>

//               <Grid item xs={6} sm={2} md={1}>
//                 <Button
//                   fullWidth
//                   variant="outlined"
//                   size="small"
//                   onClick={handleOpen}
//                   disabled={loading}
//                   startIcon={<CalendarMonth />}
//                 >
//                   {!isMobile && 'Date'}
//                 </Button>
//               </Grid>

//               <Grid item xs={6} sm={2} md={2}>
//                 {activeTab === 'Approval Pending' ? (
//                   <Button
//                     fullWidth
//                     variant="contained"
//                     color="primary"
//                     size="small"
//                     startIcon={<CheckCircle />}
//                     onClick={() => handleBulkAction('approve')}
//                     disabled={selectedIds.length === 0 || loading}
//                   >
//                     {!isMobile && 'Approve'}
//                   </Button>
//                 ) : (
//                   <Button
//                     fullWidth
//                     variant="contained"
//                     color="error"
//                     size="small"
//                     startIcon={<Delete />}
//                     onClick={() => handleBulkAction('delete')}
//                     disabled={selectedIds.length === 0 || loading}
//                   >
//                     {!isMobile && 'Delete'}
//                   </Button>
//                 )}
//               </Grid>
//             </Grid>
//           </Grid>

//           <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
//             <DialogTitle>Select Date Range</DialogTitle>
//             <DialogContent>
//               <Box display="flex" flexDirection="column" gap={2} mt={1}>
//                 <DatePicker
//                   label="Start Date"
//                   value={startDate}
//                   onChange={setStartDate}
//                   disabled={loading}
//                 />
//                 <DatePicker
//                   label="End Date"
//                   value={endDate}
//                   onChange={setEndDate}
//                   disabled={loading}
//                 />
//               </Box>
//             </DialogContent>
//             <DialogActions>
//               <Button onClick={handleClose} color="secondary" disabled={loading}>
//                 Cancel
//               </Button>
//               <Button onClick={handleClose} color="primary" disabled={loading}>
//                 Apply
//               </Button>
//             </DialogActions>
//           </Dialog>
//         </Grid>

//         <TableContainer
//           component={Paper}
//           sx={{
//             mt: 1
//           }}
//         >
//           <Table stickyHeader size="small">
//             <TableHead>
//               <TableRow>
//                 <TableCell padding="checkbox" sx={{ width: 48 }}>
//                   <Checkbox
//                     indeterminate={selectedIds.length > 0 && selectedIds.length < members.length}
//                     checked={members.length > 0 && selectedIds.length === members.length}
//                     onChange={handleSelectAllClick}
//                     disabled={activeTab === 'Verification Pending' || loading}
//                   />
//                 </TableCell>
//                 <TableCell sx={{ minWidth: isMobile ? 60 : 80 }}>
//                   <Typography variant={typography.body2}>Avatar</Typography>
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant={typography.body2}>Full Name</Typography>
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant={typography.body2}>Email</Typography>
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant={typography.body2}>Phone</Typography>
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant={typography.body2}>Groups</Typography>
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant={typography.body2}>Role</Typography>
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant={typography.body2}>Department</Typography>
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant={typography.body2}>Status</Typography>
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant={typography.body2}>Created By</Typography>
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant={typography.body2}>Creation Date</Typography>
//                 </TableCell>
//                 <TableCell>
//                   <Typography variant={typography.body2}>Actions</Typography>
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={isMobile ? 4 : 12} align="center">
//                     <CircularProgress />
//                   </TableCell>
//                 </TableRow>
//               ) : filteredMembers.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={isMobile ? 4 : 12} align="center">
//                     <Typography variant={typography.body2}>No members found</Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 filteredMembers.map((member: FormData) => {
//                   const statusInfo = statusMap[member.status as keyof typeof statusMap] ?? {
//                     label: 'Unknown',
//                     color: 'default' as const
//                   };
//                   return (
//                     <TableRow
//                       key={member.id}
//                       hover
//                       sx={{
//                         backgroundColor:
//                           member.id === selectedMember?.id ? '#e0f7fa' : 'transparent'
//                       }}
//                     >
//                       <TableCell padding="checkbox">
//                         <Checkbox
//                           checked={selectedIds.includes(member.id!)}
//                           onChange={() => handleCheckboxClick(member.id!)}
//                           disabled={activeTab === 'Verification Pending' || loading}
//                         />
//                       </TableCell>
//                       <TableCell>
//                         <Avatar
//                           src={
//                             member.id
//                               ? avatarUrls[member.id] || '/default-avatar.png'
//                               : '/default-avatar.png'
//                           }
//                           sx={{ width: isMobile ? 40 : 48, height: isMobile ? 40 : 48 }}
//                           imgProps={{ onError: handleAvatarError }}
//                         />
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant={typography.body2} noWrap>
//                           {member.name || 'N/A'}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant={typography.body2} noWrap>
//                           {member.email || 'N/A'}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant={typography.body2} noWrap>
//                           {member.phone || 'N/A'}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Box display="flex" flexWrap="wrap" gap={0.5}>
//                           {(member.groups || []).slice(0, 2).map((groupId) => {
//                             const groupName =
//                               groups.find((g) => g.group_id === groupId)?.label || 'Unknown';
//                             return (
//                               <Chip
//                                 key={groupId}
//                                 label={
//                                   <Typography variant={typography.caption}>{groupName}</Typography>
//                                 }
//                                 size="small"
//                                 color="primary"
//                               />
//                             );
//                           })}
//                           {(member.groups || []).length > 2 && (
//                             <Chip label={`+${(member.groups || []).length - 2}`} size="small" />
//                           )}
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant={typography.body2} noWrap component="div">
//                           {Array.isArray(member.role) && member.role.length > 0 ? (
//                             member.role.flatMap((roleEntry, i) => {
//                               if (!Array.isArray(roleEntry.label)) return [];

//                               return roleEntry.label.map(
//                                 (labelObj: { label: string }, j: number) => (
//                                   <Chip
//                                     key={`${i}-${j}`}
//                                     label={
//                                       <Typography variant={typography.caption}>
//                                         {labelObj.label}
//                                       </Typography>
//                                     }
//                                     size="small"
//                                     variant="outlined"
//                                     sx={{
//                                       fontWeight: 400,
//                                       height: 22,
//                                       fontSize: '0.75rem',
//                                       mr: 0.5,
//                                       mb: 0.5
//                                     }}
//                                   />
//                                 )
//                               );
//                             })
//                           ) : (
//                             <Chip
//                               label={<Typography variant={typography.caption}>N/A</Typography>}
//                               size="small"
//                               variant="outlined"
//                               sx={{ fontWeight: 400, height: 22, fontSize: '0.75rem' }}
//                             />
//                           )}
//                         </Typography>
//                       </TableCell>

//                       <TableCell>
//                         <Typography variant={typography.body2} noWrap>
//                           <Chip
//                             label={
//                               <Typography variant={typography.caption}>
//                                 {member.department
//                                   ? groups.find((g) => g.group_id === member.department)?.label ||
//                                     'Unknown'
//                                   : 'N/A'}
//                               </Typography>
//                             }
//                             size="small"
//                             variant="outlined"
//                             sx={{ fontWeight: 400, height: 22, fontSize: '0.75rem' }}
//                           />
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Chip
//                           label={
//                             <Typography variant={typography.caption}>{statusInfo.label}</Typography>
//                           }
//                           size="small"
//                           color={statusInfo.color}
//                         />
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant={typography.body2} noWrap>
//                           {member.created_by || 'N/A'}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant={typography.body2} noWrap>
//                           {member.creation_date_time
//                             ? new Date(member.creation_date_time).toLocaleDateString()
//                             : 'N/A'}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Box sx={{ display: 'flex', gap: 0.5 }}>
//                           {activeTab === 'Approved' && (
//                             <IconButton
//                               edge="end"
//                               onClick={() => handleListItemClick(member)}
//                               disabled={loading}
//                               title="Edit"
//                               size="small"
//                             >
//                               <Edit fontSize={isMobile ? 'small' : 'medium'} />
//                             </IconButton>
//                           )}
//                           {(activeTab === 'Approval Pending' ||
//                             activeTab === 'Rejected Applicants' ||
//                             activeTab === 'Approved') && (
//                             <IconButton
//                               edge="end"
//                               onClick={() => {
//                                 dispatch(setSelectedMember(member));
//                                 handleIndividualAction('delete');
//                               }}
//                               disabled={loading}
//                               title="Delete"
//                               color="error"
//                               size="small"
//                             >
//                               <Delete fontSize={isMobile ? 'small' : 'medium'} />
//                             </IconButton>
//                           )}
//                         </Box>
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//         {error && (
//           <Typography color="error" variant={typography.body2} sx={{ mt: 1 }}>
//             {error}
//           </Typography>
//         )}
//       </Box>
//     </Container>
//   );
// };

// export default MemberReviewForm;




import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useLocation } from 'react-router-dom';
import {
  fetchApplicants,
  setSelectedMember,
  setSelectedIds,
  addMember,
  updateMember,
  performApplicantAction,
  clearAvatarError,
  setActiveTab,
  updateAvatarUrl,
  FormData,
  MembersReviewState,
  getAvatarUrl
} from 'slices/NdisSlices/platformAdmin/MembersReviewFormSlice';
import { fetchGroups } from 'slices/NdisSlices/platformAdmin/PlatformAdminSlice';
import { fetchRoles } from 'slices/NdisSlices/platformAdmin/ManageRolesSlice';
import { RootState, AppDispatch } from 'store';

import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Select from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import { Typography, TypographyProps } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ClearIcon from '@mui/icons-material/Clear';
import Cancel from '@mui/icons-material/Cancel';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import Search from '@mui/icons-material/Search';
import CloudUpload from '@mui/icons-material/CloudUpload';
import CalendarMonth from '@mui/icons-material/CalendarMonth';

// Define interfaces for Group and Role
interface Group {
  group_id: string;
  label: string;
}

interface Role {
  role_id: string;
  label: string;
}

const schema: yup.ObjectSchema<FormData> = yup.object().shape({
  id: yup.string().optional(),
  name: yup.string().required('Full Name is required'),
  username: yup.string().optional(),
  role: yup
    .array()
    .of(
      yup.object().shape({
        role_id: yup.string().required(),
        label: yup.string().required()
      })
    )
    .optional(),
  gender: yup.string().optional(),
  phone: yup.string().required('Phone is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  dob: yup.date().required('Date of Birth is required').typeError('Invalid date'),
  address: yup.string().optional(),
  projects: yup.array().of(yup.string().defined()).optional(),
  groups: yup.array().of(yup.string().defined()).optional(),
  avartar: yup.string().optional(),
  creation_date_time: yup.string().optional(),
  created_by: yup.string().optional(),
  department: yup.string().optional(),
  status: yup
    .string()
    .oneOf(['active', 'inactive', 'verify pending', 'approval pending', 'rejected'])
    .required('Status is required'),
  isActive: yup.boolean().optional()
});

const defaultFormValues: FormData = {
  id: '',
  name: '',
  username: '',
  role: [],
  gender: 'male',
  phone: '',
  email: '',
  dob: new Date(),
  address: '',
  projects: [],
  groups: [],
  avartar: '',
  creation_date_time: '',
  created_by: '',
  department: '',
  status: 'active',
  isActive: true
};

const validTabs = [
  'Verification Pending',
  'Approval Pending',
  'Rejected Applicants',
  'Approved'
] as const;

const useResponsiveTypography = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return {
    h4: (isMobile ? 'h5' : 'h4') as TypographyProps['variant'],
    h5: (isMobile ? 'h6' : 'h5') as TypographyProps['variant'],
    h6: (isMobile ? 'subtitle1' : 'h6') as TypographyProps['variant'],
    subtitle1: (isMobile ? 'subtitle2' : 'subtitle1') as TypographyProps['variant'],
    body1: (isMobile ? 'body2' : 'body1') as TypographyProps['variant'],
    body2: (isMobile ? 'caption' : 'body2') as TypographyProps['variant'],
    caption: 'caption' as TypographyProps['variant']
  };
};

const MemberReviewForm: React.FC = () => {
  const scrollableDivRef = useRef<HTMLDivElement>(null);
  const formRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const typography = useResponsiveTypography();

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [isActive, setIsActive] = useState(true);
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [selectedClient, setSelectedClient] = useState<{ label: string } | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'error' | 'success'>('error');
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const [avatarPreview, setAvatarPreview] = useState<string | null>(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmationAction, setConfirmationAction] = useState<
    'approve' | 'reject' | 'delete' | null
  >(null);
  const [isBulkAction, setIsBulkAction] = useState(false);
  const avatarBlobUrls = useRef<{ [id: string]: string }>({});

  const initialLoadComplete = useRef(false);

  const dispatch = useDispatch<AppDispatch>();
  const {
    members,
    selectedMember,
    selectedIds,
    loading,
    error,
    avatarLoading,
    avatarError,
    avatarUrls,
    activeTab
  } = useSelector((state: RootState) => state.membersReview as MembersReviewState);

  const groups = useSelector((state: RootState) => (state.platformAdmin?.groups || []) as Group[]);
  const { roles } = useSelector((state: RootState) => state.manageRoles as { roles: Role[] });

  const selectedProjectId = useSelector(
    (state: RootState) => (state as any).homeTilesServices?.selectedProjectId || ''
  );

  const selectedServiceTitle = useSelector(
    (state: RootState) => (state as any).serviceSelected?.selectedServiceTitle || ''
  );

  const userDetails = localStorage.getItem('user-details');
  const loggedInWorkerName = userDetails ? JSON.parse(userDetails)?.name || '' : '';

  const location = useLocation();
  const componentParentId = location.pathname;

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors }
  } = useForm<FormData>({
    resolver: yupResolver(schema),
    defaultValues: defaultFormValues
  });

  // Persist activeTab in localStorage
  useEffect(() => {
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  // Restore activeTab on mount
  useEffect(() => {
    if (!initialLoadComplete.current) {
      const savedTab = localStorage.getItem('activeTab');
      if (savedTab && validTabs.includes(savedTab as any)) {
        dispatch(setActiveTab(savedTab as any));
        dispatch(fetchApplicants(savedTab as any));
      } else {
        dispatch(setActiveTab('Verification Pending'));
        dispatch(fetchApplicants('Verification Pending'));
      }
      dispatch(fetchGroups());
      dispatch(fetchRoles());
      dispatch(setSelectedMember(null));
      reset(defaultFormValues);
      initialLoadComplete.current = true;
    }
  }, [dispatch, reset]);

  // Fetch avatars for members
  useEffect(() => {
    const fetchAvatars = async () => {
      for (const member of members) {
        try {
          const url = await getAvatarUrl(member.avartar || '');
          dispatch(updateAvatarUrl({ id: member.id || '', url }));
          avatarBlobUrls.current[member.id || ''] = url;
        } catch (err) {
          console.error(`Failed to fetch avatar for member ${member.id}:`, err);
        }
      }
    };
    fetchAvatars();
  }, [members, dispatch]);

  // Update avatar preview when avatarFile changes
  useEffect(() => {
    if (avatarFile) {
      const previewUrl = URL.createObjectURL(avatarFile);
      setAvatarPreview(previewUrl);
      return () => URL.revokeObjectURL(previewUrl);
    } else {
      setAvatarPreview(null);
    }
  }, [avatarFile]);

  // Cleanup blob URLs on unmount
  useEffect(() => {
    return () => {
      Object.values(avatarBlobUrls.current).forEach((url) => {
        if (url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
      });
      avatarBlobUrls.current = {};
      if (avatarPreview) {
        URL.revokeObjectURL(avatarPreview);
      }
    };
  }, [avatarPreview]);

  // Reset form when selectedMember changes to null
  useEffect(() => {
    if (!selectedMember) {
      reset(defaultFormValues);
      setAvatarFile(null);
      setAvatarPreview(null);
      setIsActive(true);
      setSelectedClient(null);
    }
  }, [selectedMember, reset]);

  useEffect(() => {
    if (error || avatarError) {
      setSnackbarMessage(error || avatarError || 'An error occurred');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  }, [error, avatarError]);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
    dispatch(clearAvatarError());
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirmationOpen = (
    action: 'approve' | 'reject' | 'delete',
    isBulk: boolean = false
  ) => {
    setConfirmationAction(action);
    setIsBulkAction(isBulk);
    setConfirmationOpen(true);
  };

  const handleConfirmationClose = () => {
    setConfirmationOpen(false);
    setConfirmationAction(null);
    setIsBulkAction(false);
  };

  const handleConfirmAction = async () => {
    if (!confirmationAction) return;

    if (isBulkAction) {
      await handleBulkAction(confirmationAction);
    } else {
      await handleIndividualAction(confirmationAction);
    }
    handleConfirmationClose();
  };

  const handleTabChange = (
    event: React.SyntheticEvent,
    newValue: 'Verification Pending' | 'Approval Pending' | 'Rejected Applicants' | 'Approved'
  ) => {
    dispatch(setActiveTab(newValue));
    dispatch(fetchApplicants(newValue));
    dispatch(setSelectedMember(null));
    dispatch(setSelectedIds([]));
    reset(defaultFormValues);
    setSelectedClient(null);
    setIsActive(true);
    setAvatarFile(null);
    setAvatarPreview(null);
  };

  const handleAvatarError = useCallback((e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement;
    target.onerror = null;
    target.src = '/default-avatar.png';
  }, []);

  const onSubmit: SubmitHandler<FormData> = async (data) => {
    if (activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants') return;

    const finalData = {
      ...data,
      avartar: avatarFile ? data.avartar : selectedMember?.avartar || ''
    };

    const payload = {
      data: finalData,
      selectedProjectId,
      selectedServiceTitle,
      loggedInWorkerName,
      componentParentId,
      user_whoRequested_id: selectedClient?.label || '',
      avatarFile
    };

    try {
      if (selectedMember?.id) {
        const result = await dispatch(updateMember(payload)).unwrap();
        setSnackbarMessage('Member updated successfully');
        setSnackbarSeverity('success');
        if (avatarFile && avatarPreview && selectedMember.id) {
          dispatch(updateAvatarUrl({ id: selectedMember.id, url: avatarPreview }));
          avatarBlobUrls.current[selectedMember.id] = avatarPreview;
        } else if (finalData.avartar && selectedMember.id) {
          dispatch(updateAvatarUrl({ id: selectedMember.id, url: '' }));
          try {
            const newAvatarUrl = await getAvatarUrl(finalData.avartar);
            dispatch(updateAvatarUrl({ id: selectedMember.id, url: newAvatarUrl }));
            avatarBlobUrls.current[selectedMember.id] = newAvatarUrl;
          } catch (err) {
            console.error(`Failed to fetch updated avatar for ${selectedMember.id}:`, err);
            dispatch(updateAvatarUrl({ id: selectedMember.id, url: '/default-avatar.png' }));
          }
        }
        await dispatch(fetchApplicants(activeTab)).unwrap();
      } else {
        await dispatch(addMember(payload)).unwrap();
        setSnackbarMessage('Member added successfully');
        setSnackbarSeverity('success');
        await dispatch(fetchApplicants(activeTab)).unwrap();
      }

      setSnackbarOpen(true);
      reset(defaultFormValues);
      setAvatarFile(null);
      setAvatarPreview(null);
      setIsActive(true);
      setSelectedClient(null);
      dispatch(setSelectedMember(null));
      dispatch(setSelectedIds([]));
    } catch (err) {
      console.error('Error during submit:', err);
      setSnackbarMessage('Failed to save member');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleListItemClick = (member: FormData) => {
    if (scrollableDivRef.current) {
      scrollableDivRef.current.scrollTo({
        top: formRef.current?.offsetTop || 0,
        behavior: 'smooth'
      });
    }

    if (activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants') return;

    const transformedRoles =
      member.role?.flatMap((roleItem) => {
        if (Array.isArray(roleItem.role_id)) {
          return roleItem.role_id.map((role) => ({
            role_id: role.role_id,
            label: role.label
          }));
        } else if (roleItem.role_id) {
          return [
            {
              role_id: roleItem.role_id,
              label: roleItem.label || ''
            }
          ];
        }
        return [];
      }) || [];

    dispatch(setSelectedMember(member));
    setIsActive(member.isActive ?? member.status === 'active');

    const formData = {
      ...member,
      dob: member.dob ? new Date(member.dob) : new Date(),
      projects: member.projects || [],
      groups: member.groups || [],
      status: member.status || 'active',
      avartar: member.avartar || '',
      isActive: member.isActive ?? member.status === 'active',
      role: transformedRoles,
      name: member.name || '',
      email: member.email || '',
      phone: member.phone || '',
      address: member.address || '',
      gender: member.gender || 'male',
      username: member.username || member.email || '',
      department: member.department || '',
      creation_date_time: member.creation_date_time || '',
      created_by: member.created_by || ''
    };

    reset(formData);
    setAvatarFile(null);
    setAvatarPreview(null);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (activeTab === 'Verification Pending' && !event.target.checked) return;

    if (event.target.checked) {
      const newSelecteds = members
        .map((member: FormData) => member.id!)
        .filter((id): id is string => !!id);
      dispatch(setSelectedIds(newSelecteds));
      return;
    }
    dispatch(setSelectedIds([]));
  };

  const handleCheckboxClick = (id: string) => {
    if (activeTab === 'Verification Pending' && !selectedIds.includes(id)) return;

    const selectedIndex = selectedIds.indexOf(id);
    let newSelected: string[] = [];

    if (selectedIndex === -1) {
      newSelected = [...selectedIds, id];
    } else {
      newSelected = selectedIds.filter((item: string) => item !== id);
    }

    dispatch(setSelectedIds(newSelected));
  };

  const handleBulkAction = async (action: 'approve' | 'reject' | 'delete') => {
    if ((activeTab === 'Verification Pending' && action !== 'delete') || selectedIds.length === 0)
      return;

    const payload = selectedIds.map((id: string) => ({
      id,
      email: members.find((member: FormData) => member.id === id)?.email || ''
    }));

    try {
      await dispatch(
        performApplicantAction({ membersData: payload, action, tab: activeTab })
      ).unwrap();
      setSnackbarMessage(`Bulk ${action} successful`);
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      dispatch(setSelectedIds([]));
      if (selectedMember && payload.some((p: { id: string }) => p.id === selectedMember.id)) {
        reset(defaultFormValues);
        dispatch(setSelectedMember(null));
        setSelectedClient(null);
        setIsActive(true);
        setAvatarFile(null);
        setAvatarPreview(null);
      }
      await dispatch(fetchApplicants(activeTab)).unwrap();
    } catch (err) {
      setSnackbarMessage(`Failed to perform bulk ${action}`);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleIndividualAction = async (action: 'approve' | 'reject' | 'delete') => {
    if ((activeTab === 'Verification Pending' && action !== 'delete') || !selectedMember?.id)
      return;

    const payload = [{ id: selectedMember.id, email: selectedMember.email }];

    try {
      await dispatch(
        performApplicantAction({ membersData: payload, action, tab: activeTab })
      ).unwrap();
      setSnackbarMessage(`${action.charAt(0).toUpperCase() + action.slice(1)} successful`);
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      reset(defaultFormValues);
      dispatch(setSelectedMember(null));
      dispatch(setSelectedIds([]));
      setSelectedClient(null);
      setIsActive(true);
      setAvatarFile(null);
      setAvatarPreview(null);
      await dispatch(fetchApplicants(activeTab)).unwrap();
    } catch (err) {
      setSnackbarMessage(`Failed to ${action} member`);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleAvatarUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants') return;

    const file = event.target.files?.[0];
    if (file) {
      setAvatarFile(file);
      const { email } = getValues();
      if (email) {
        const extension = file.name.split('.').pop() || 'png';
        setValue(
          'avartar',
          `Users/ApprovedMembers/${email.replace('@', '_').replace('.', '_')}/image.${extension}`
        );
      }
    }
  };

  const handleAvatarRemove = () => {
    if (activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants') return;

    setValue('avartar', '');
    setAvatarFile(null);
    setAvatarPreview(null);
  };

  const filteredMembers = React.useMemo(() => {
    return members.filter((member: FormData) =>
      member.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [members, searchTerm]);

  const statusMap = {
    active: { label: 'Active', color: 'success' as const },
    inactive: { label: 'Inactive', color: 'error' as const },
    pending: { label: 'Pending', color: 'warning' as const }
  };

  return (
    <Container
      maxWidth="lg"
      sx={{
        py: isMobile ? 1 : 3,
        px: isMobile ? 1 : 3
      }}
      ref={scrollableDivRef}
    >
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog
        open={confirmationOpen}
        onClose={handleConfirmationClose}
        aria-labelledby="confirmation-dialog-title"
      >
        <DialogTitle id="confirmation-dialog-title">
          Confirm{' '}
          {confirmationAction
            ? `${confirmationAction.charAt(0).toUpperCase()}${confirmationAction.slice(1)}`
            : 'Action'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to {confirmationAction || 'perform this action'}{' '}
            {isBulkAction ? 'selected members' : 'this member'}?
            {confirmationAction === 'delete' && ' This action cannot be undone.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmationClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleConfirmAction} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ mb: isMobile ? 1 : 2 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant={typography.h4} fontWeight="bold">
              Review Member
            </Typography>
          </Grid>
          {(activeTab === 'Verification Pending' ||
            activeTab === 'Approval Pending' ||
            activeTab === 'Approved') && (
            <Grid item>
              <Box sx={{ display: 'flex', gap: 1 }}>
                {activeTab === 'Approval Pending' && (
                  <>
                    <Button
                      variant="outlined"
                      color="secondary"
                      size="small"
                      startIcon={<Cancel />}
                      onClick={() => handleConfirmationOpen('reject')}
                      disabled={!selectedMember || loading}
                    >
                      {isMobile ? '' : 'Reject'}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<CheckCircle />}
                      onClick={() => handleConfirmationOpen('approve')}
                      disabled={!selectedMember || loading}
                    >
                      {isMobile ? '' : 'Approve'}
                    </Button>
                  </>
                )}
                {(activeTab === 'Verification Pending' ||
                  activeTab === 'Approval Pending' ||
                  activeTab === 'Approved') && (
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    startIcon={<Delete />}
                    onClick={() => handleConfirmationOpen('delete')}
                    disabled={!selectedMember || loading}
                  >
                    {isMobile ? '' : 'Delete'}
                  </Button>
                )}
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>

      <Grid container spacing={isMobile ? 1 : 3} ref={formRef}>
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              p: isMobile ? 1 : 2,
              textAlign: 'center',
              height: '100%'
            }}
          >
            <CardContent sx={{ p: isMobile ? 1 : 2 }}>
              <Avatar
                src={
                  avatarPreview ||
                  (selectedMember?.id
                    ? avatarUrls[selectedMember.id] || '/default-avatar.png'
                    : '/default-avatar.png')
                }
                sx={{
                  width: isMobile ? 60 : 80,
                  height: isMobile ? 60 : 80,
                  mx: 'auto',
                  mb: isMobile ? 1 : 2
                }}
                imgProps={{ onError: handleAvatarError }}
              />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: isMobile ? 0.5 : 1,
                  flexWrap: isMobile ? 'wrap' : 'nowrap'
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  component="label"
                  disabled={
                    !selectedMember ||
                    avatarLoading ||
                    activeTab === 'Verification Pending' ||
                    activeTab === 'Rejected Applicants'
                  }
                  sx={{ minWidth: isMobile ? '100%' : 'auto', mb: isMobile ? 1 : 0 }}
                >
                  {avatarLoading ? <CircularProgress size={20} /> : 'Change'}
                  <input type="file" hidden onChange={handleAvatarUpload} accept="image/*" />
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  color="secondary"
                  onClick={handleAvatarRemove}
                  disabled={
                    !selectedMember ||
                    avatarLoading ||
                    activeTab === 'Verification Pending' ||
                    activeTab === 'Rejected Applicants'
                  }
                  sx={{ minWidth: isMobile ? '100%' : 'auto' }}
                >
                  Remove
                </Button>
              </Box>
            </CardContent>
            <Box
              sx={{
                mt: isMobile ? 1 : 2,
                p: isMobile ? 1 : 2,
                border: '2px dashed #ccc',
                borderRadius: 1,
                textAlign: 'center',
                cursor:
                  activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants'
                    ? 'not-allowed'
                    : 'pointer',
                bgcolor:
                  activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants'
                    ? '#f5f5f5'
                    : '#fafafa',
                '&:hover': {
                  bgcolor:
                    activeTab === 'Verification Pending' || activeTab === 'Rejected Applicants'
                      ? '#f5f5f5'
                      : '#f0f0f0'
                }
              }}
            >
              <CloudUpload sx={{ fontSize: isMobile ? 30 : 40, color: 'gray' }} />
              <Typography variant={typography.body2} fontWeight={500} mt={1}>
                Drag & Drop your files here
              </Typography>
              <Typography variant={typography.body2} color="gray">
                OR
              </Typography>
              <Button
                component="label"
                variant="outlined"
                size="small"
                startIcon={<CloudUpload />}
                sx={{
                  mt: 1,
                  width: isMobile ? '100%' : 'auto'
                }}
                disabled={
                  !selectedMember ||
                  avatarLoading ||
                  activeTab === 'Verification Pending' ||
                  activeTab === 'Rejected Applicants'
                }
              >
                {avatarLoading ? <CircularProgress size={20} /> : 'Browse Files'}
                <input type="file" hidden onChange={handleAvatarUpload} accept="image/*" />
              </Button>
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} md={8}>
          <Card sx={{ p: isMobile ? 1 : 2, height: '100%' }}>
            <CardContent sx={{ p: isMobile ? 1 : 2 }}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={isMobile ? 1 : 2}
                  flexDirection={isMobile ? 'column' : 'row'}
                  gap={isMobile ? 1 : 0}
                >
                  <Typography variant={typography.h6} fontWeight={600}>
                    General Information
                  </Typography>
                  <Controller
                    name="isActive"
                    control={control}
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Switch
                            checked={field.value ?? isActive}
                            onChange={(e) => {
                              field.onChange(e.target.checked);
                              setIsActive(e.target.checked);
                              setValue('status', e.target.checked ? 'active' : 'inactive');
                            }}
                            color="primary"
                            disabled={
                              activeTab === 'Verification Pending' ||
                              activeTab === 'Rejected Applicants' ||
                              loading
                            }
                            sx={{
                              '& .MuiSwitch-track': {
                                background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
                              },
                              '& .Mui-checked': {
                                '& .MuiSwitch-track': {
                                  background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)'
                                },
                                '& .MuiSwitch-thumb': {
                                  backgroundColor: '#2196F3 !important'
                                }
                              },
                              '& .MuiSwitch-thumb': {
                                backgroundColor: '#ff4081'
                              }
                            }}
                          />
                        }
                        label={
                          <Typography variant={typography.body2}>
                            {field.value ?? isActive ? 'Active' : 'Inactive'}
                          </Typography>
                        }
                      />
                    )}
                  />
                </Box>

                <Grid container spacing={isMobile ? 1 : 2}>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="name"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Full Name"
                          variant="outlined"
                          fullWidth
                          size="small"
                          error={!!errors.name}
                          helperText={errors.name?.message}
                          disabled={
                            activeTab === 'Verification Pending' ||
                            activeTab === 'Rejected Applicants' ||
                            loading
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="username"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Username"
                          variant="outlined"
                          fullWidth
                          size="small"
                          error={!!errors.username}
                          helperText={errors.username?.message}
                          disabled={
                            activeTab === 'Verification Pending' ||
                            activeTab === 'Rejected Applicants' ||
                            loading
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="gender"
                      control={control}
                      render={({ field }) => (
                        <RadioGroup row {...field}>
                          <FormControlLabel
                            value="male"
                            control={<Radio size="small" checked={field.value === 'male'} />}
                            label={<Typography variant={typography.body2}>Male</Typography>}
                            disabled={
                              activeTab === 'Verification Pending' ||
                              activeTab === 'Rejected Applicants' ||
                              loading
                            }
                          />
                          <FormControlLabel
                            value="female"
                            control={<Radio size="small" checked={field.value === 'female'} />}
                            label={<Typography variant={typography.body2}>Female</Typography>}
                            disabled={
                              activeTab === 'Verification Pending' ||
                              activeTab === 'Rejected Applicants' ||
                              loading
                            }
                          />
                          <FormControlLabel
                            value="other"
                            control={<Radio size="small" checked={field.value === 'other'} />}
                            label={<Typography variant={typography.body2}>Other</Typography>}
                            disabled={
                              activeTab === 'Verification Pending' ||
                              activeTab === 'Rejected Applicants' ||
                              loading
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="phone"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Phone"
                          variant="outlined"
                          fullWidth
                          size="small"
                          error={!!errors.phone}
                          helperText={errors.phone?.message}
                          disabled={
                            activeTab === 'Verification Pending' ||
                            activeTab === 'Rejected Applicants' ||
                            loading
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Email"
                          variant="outlined"
                          fullWidth
                          size="small"
                          error={!!errors.email}
                          helperText={errors.email?.message}
                          disabled={
                            activeTab === 'Verification Pending' ||
                            activeTab === 'Rejected Applicants' ||
                            loading
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="dob"
                      control={control}
                      render={({ field }) => (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            label="Date of Birth"
                            value={field.value}
                            onChange={(date: any) => field.onChange(date)}
                            maxDate={new Date()}
                            slots={{ textField: TextField }}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: 'small',
                                error: !!errors.dob,
                                helperText: errors.dob?.message,
                                disabled:
                                  activeTab === 'Verification Pending' ||
                                  activeTab === 'Rejected Applicants' ||
                                  loading
                              }
                            }}
                          />
                        </LocalizationProvider>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="address"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Address (Suburb, State, Country, Postcode)"
                          variant="outlined"
                          fullWidth
                          size="small"
                          error={!!errors.address}
                          helperText={errors.address?.message}
                          disabled={
                            activeTab === 'Verification Pending' ||
                            activeTab === 'Rejected Applicants' ||
                            loading
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="department"
                      control={control}
                      render={({ field }) => (
                        <FormControl
                          fullWidth
                          size="small"
                          error={!!errors.department}
                          disabled={
                            activeTab === 'Verification Pending' ||
                            activeTab === 'Rejected Applicants' ||
                            loading
                          }
                        >
                          <InputLabel>Department</InputLabel>
                          <Select
                            {...field}
                            label="Department"
                            onChange={(e) => field.onChange(e.target.value)}
                            renderValue={(selected) =>
                              groups.find((g: Group) => g.group_id === selected)?.label || ''
                            }
                            endAdornment={
                              field.value && (
                                <IconButton
                                  sx={{ display: 'flex', mr: 1 }}
                                  onClick={() => field.onChange('')}
                                  size="small"
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              )
                            }
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {groups.map((group: Group) => (
                              <MenuItem key={group.group_id} value={group.group_id}>
                                {group.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors.department && (
                            <Typography color="error" variant={typography.caption}>
                              {errors.department.message}
                            </Typography>
                          )}
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Controller
                      name="role"
                      control={control}
                      render={({ field }) => (
                        <FormControl
                          fullWidth
                          size="small"
                          error={!!errors.role}
                          disabled={
                            activeTab === 'Verification Pending' ||
                            activeTab === 'Rejected Applicants' ||
                            loading
                          }
                          sx={{ bgcolor: 'background.paper' }}
                        >
                          <InputLabel sx={{ color: 'text.secondary' }}>Role</InputLabel>
                          <Select
                            {...field}
                            label="Role"
                            multiple
                            value={(field.value || []).map((r) => r.role_id)}
                            onChange={(e) => {
                              const selectedIds = e.target.value as string[];
                              const selectedRoles = selectedIds
                                .map((id) => {
                                  const role = roles.find((r: Role) => r.role_id === id);
                                  return role ? { role_id: role.role_id, label: role.label } : null;
                                })
                                .filter((r): r is { role_id: string; label: string } => r !== null);
                              field.onChange(selectedRoles);
                            }}
                            renderValue={(selected) =>
                              (selected as string[])
                                .map((id) => roles.find((r: Role) => r.role_id === id)?.label || id)
                                .join(', ')
                            }
                            sx={{ color: 'text.primary' }}
                          >
                            {roles.map((role: Role) => (
                              <MenuItem key={role.role_id} value={role.role_id}>
                                {role.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="groups"
                      control={control}
                      render={({ field }) => (
                        <FormControl
                          fullWidth
                          size="small"
                          error={!!errors.groups}
                          disabled={
                            activeTab === 'Verification Pending' ||
                            activeTab === 'Rejected Applicants' ||
                            loading
                          }
                        >
                          <InputLabel>Groups</InputLabel>
                          <Select
                            {...field}
                            multiple
                            label="Groups"
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(typeof value === 'string' ? value.split(',') : value);
                            }}
                            renderValue={(selected) =>
                              (selected as string[])
                                .map(
                                  (id) => groups.find((g: Group) => g.group_id === id)?.label || id
                                )
                                .join(', ')
                            }
                            endAdornment={
                              field.value &&
                              (field.value as string[]).length > 0 && (
                                <IconButton
                                  sx={{ display: 'flex', mr: 1 }}
                                  onClick={() => field.onChange([])}
                                  size="small"
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              )
                            }
                          >
                            {groups.map((group: Group) => (
                              <MenuItem key={group.group_id} value={group.group_id}>
                                {group.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors.groups && (
                            <Typography color="error" variant={typography.caption}>
                              {errors.groups.message}
                            </Typography>
                          )}
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      size="small"
                      disabled={
                        activeTab === 'Verification Pending' ||
                        activeTab === 'Rejected Applicants' ||
                        activeTab === 'Approval Pending' ||
                        loading
                      }
                      sx={{ width: isMobile ? '100%' : 'auto' }}
                    >
                      {loading ? (
                        <CircularProgress size={20} />
                      ) : selectedMember ? (
                        'Update'
                      ) : (
                        'Save'
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ mt: isMobile ? 2 : 4 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="member status tabs"
          sx={{ mb: isMobile ? 1 : 2 }}
          variant={isMobile ? 'scrollable' : 'standard'}
          scrollButtons="auto"
        >
          <Tab label="Verification Pending" value="Verification Pending" disabled={loading} />
          <Tab label="Approval Pending" value="Approval Pending" disabled={loading} />
          <Tab label="Rejected Applicants" value="Rejected Applicants" disabled={loading} />
          <Tab label="Approved Members" value="Approved" disabled={loading} />
        </Tabs>

        <Grid container spacing={1} alignItems="center">
          <Grid item xs={12}>
            <Typography variant={typography.h6} fontWeight={600}>
              Member List
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={12} sm={6} md={7}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  placeholder="Search members..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    )
                  }}
                  disabled={loading}
                />
              </Grid>

              <Grid item xs={6} sm={3} md={2}>
                <Button
                  fullWidth
                  variant="outlined"
                  size="small"
                  onClick={handleOpen}
                  disabled={loading}
                  startIcon={<CalendarMonth />}
                >
                  {!isMobile && 'Date'}
                </Button>
              </Grid>

              <Grid item xs={6} sm={3} md={3}>
                {(activeTab === 'Approval Pending' || activeTab === 'Verification Pending') && (
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    {activeTab === 'Approval Pending' && (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          startIcon={<CheckCircle />}
                          onClick={() => handleConfirmationOpen('approve', true)}
                          disabled={selectedIds.length === 0 || loading}
                        >
                          {!isMobile && 'Approve'}
                        </Button>
                        <Button
                          variant="outlined"
                          color="secondary"
                          size="small"
                          startIcon={<Cancel />}
                          onClick={() => handleConfirmationOpen('reject', true)}
                          disabled={selectedIds.length === 0 || loading}
                        >
                          {!isMobile && 'Reject'}
                        </Button>
                      </>
                    )}
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      startIcon={<Delete />}
                      onClick={() => handleConfirmationOpen('delete', true)}
                      disabled={selectedIds.length === 0 || loading}
                    >
                      {!isMobile && 'Delete'}
                    </Button>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Grid>

          <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle>Select Date Range</DialogTitle>
            <DialogContent>
              <Box display="flex" flexDirection="column" gap={2} mt={1}>
                <DatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={setStartDate}
                  disabled={loading}
                />
                <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={setEndDate}
                  disabled={loading}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="secondary" disabled={loading}>
                Cancel
              </Button>
              <Button onClick={handleClose} color="primary" disabled={loading}>
                Apply
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>

        <TableContainer
          component={Paper}
          sx={{
            mt: 1
          }}
        >
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox" sx={{ width: 48 }}>
                  <Checkbox
                    indeterminate={selectedIds.length > 0 && selectedIds.length < members.length}
                    checked={members.length > 0 && selectedIds.length === members.length}
                    onChange={handleSelectAllClick}
                    disabled={
                      (activeTab === 'Verification Pending' && selectedIds.length > 0) || loading
                    }
                  />
                </TableCell>
                <TableCell sx={{ minWidth: isMobile ? 60 : 80 }}>
                  <Typography variant={typography.body2}>Avatar</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={typography.body2}>Full Name</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={typography.body2}>Email</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={typography.body2}>Phone</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={typography.body2}>Groups</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={typography.body2}>Role</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={typography.body2}>Department</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={typography.body2}>Status</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={typography.body2}>Created By</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={typography.body2}>Creation Date</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={typography.body2}>Actions</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={isMobile ? 4 : 12} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : filteredMembers.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={isMobile ? 4 : 12} align="center">
                    <Typography variant={typography.body2}>No members found</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredMembers.map((member: FormData) => {
                  const statusInfo = statusMap[member.status as keyof typeof statusMap] ?? {
                    label: 'Unknown',
                    color: 'default' as const
                  };
                  return (
                    <TableRow
                      key={member.id}
                      hover
                      sx={{
                        backgroundColor:
                          member.id === selectedMember?.id ? '#e0f7fa' : 'transparent'
                      }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedIds.includes(member.id!)}
                          onChange={() => handleCheckboxClick(member.id!)}
                          disabled={
                            (activeTab === 'Verification Pending' &&
                              !selectedIds.includes(member.id!)) ||
                            loading
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <Avatar
                          src={
                            member.id
                              ? avatarUrls[member.id] || '/default-avatar.png'
                              : '/default-avatar.png'
                          }
                          sx={{ width: isMobile ? 40 : 48, height: isMobile ? 40 : 48 }}
                          imgProps={{ onError: handleAvatarError }}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant={typography.body2} noWrap>
                          {member.name || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant={typography.body2} noWrap>
                          {member.email || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant={typography.body2} noWrap>
                          {member.phone || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" flexWrap="wrap" gap={0.5}>
                          {(member.groups || []).slice(0, 2).map((groupId) => {
                            const groupName =
                              groups.find((g: Group) => g.group_id === groupId)?.label || 'Unknown';
                            return (
                              <Chip
                                key={groupId}
                                label={
                                  <Typography variant={typography.caption}>{groupName}</Typography>
                                }
                                size="small"
                                color="primary"
                              />
                            );
                          })}
                          {(member.groups || []).length > 2 && (
                            <Chip label={`+${(member.groups || []).length - 2}`} size="small" />
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant={typography.body2} noWrap component="div">
                          {Array.isArray(member.role) && member.role.length > 0 ? (
                            member.role.flatMap((roleEntry, i) => {
                              if (!Array.isArray(roleEntry.label)) return [];

                              return roleEntry.label.map(
                                (labelObj: { label: string }, j: number) => (
                                  <Chip
                                    key={`${i}-${j}`}
                                    label={
                                      <Typography variant={typography.caption}>
                                        {labelObj.label}
                                      </Typography>
                                    }
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                      fontWeight: 400,
                                      height: 22,
                                      fontSize: '0.75rem',
                                      mr: 0.5,
                                      mb: 0.5
                                    }}
                                  />
                                )
                              );
                            })
                          ) : (
                            <Chip
                              label={<Typography variant={typography.caption}>N/A</Typography>}
                              size="small"
                              variant="outlined"
                              sx={{ fontWeight: 400, height: 22, fontSize: '0.75rem' }}
                            />
                          )}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant={typography.body2} noWrap>
                          <Chip
                            label={
                              <Typography variant={typography.caption}>
                                {member.department
                                  ? groups.find((g: Group) => g.group_id === member.department)
                                      ?.label || 'Unknown'
                                  : 'N/A'}
                              </Typography>
                            }
                            size="small"
                            variant="outlined"
                            sx={{ fontWeight: 400, height: 22, fontSize: '0.75rem' }}
                          />
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={
                            <Typography variant={typography.caption}>{statusInfo.label}</Typography>
                          }
                          size="small"
                          color={statusInfo.color}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant={typography.body2} noWrap>
                          {member.created_by || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant={typography.body2} noWrap>
                          {member.creation_date_time
                            ? new Date(member.creation_date_time).toLocaleDateString()
                            : 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.5 }}>
                          {activeTab === 'Approved' && (
                            <IconButton
                              edge="end"
                              onClick={() => handleListItemClick(member)}
                              disabled={loading}
                              title="Edit"
                              size="small"
                            >
                              <Edit fontSize={isMobile ? 'small' : 'medium'} />
                            </IconButton>
                          )}
                          {(activeTab === 'Verification Pending' ||
                            activeTab === 'Approval Pending' ||
                            activeTab === 'Rejected Applicants' ||
                            activeTab === 'Approved') && (
                            <IconButton
                              edge="end"
                              onClick={() => {
                                dispatch(setSelectedMember(member));
                                handleConfirmationOpen('delete');
                              }}
                              disabled={loading}
                              title="Delete"
                              color="error"
                              size="small"
                            >
                              <Delete fontSize={isMobile ? 'small' : 'medium'} />
                            </IconButton>
                          )}
                          {activeTab === 'Approval Pending' && (
                            <>
                              <IconButton
                                edge="end"
                                onClick={() => {
                                  dispatch(setSelectedMember(member));
                                  handleConfirmationOpen('approve');
                                }}
                                disabled={loading}
                                title="Approve"
                                color="primary"
                                size="small"
                              >
                                <CheckCircle fontSize={isMobile ? 'small' : 'medium'} />
                              </IconButton>
                              <IconButton
                                edge="end"
                                onClick={() => {
                                  dispatch(setSelectedMember(member));
                                  handleConfirmationOpen('reject');
                                }}
                                disabled={loading}
                                title="Reject"
                                color="secondary"
                                size="small"
                              >
                                <Cancel fontSize={isMobile ? 'small' : 'medium'} />
                              </IconButton>
                            </>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {error && (
          <Typography color="error" variant={typography.body2} sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default MemberReviewForm;